export const convertToUTCTime = (date: Date) => {
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const formattedEndDate = new Date(date.getTime() - userTimezoneOffset);

  return formattedEndDate;
};
